import { ResultSkeleton } from './ResultSkeleton';

export function ResultsSkeleton() {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <ResultSkeleton key={index} />
      ))}
    </>
  );
}
